<div class="row mainwrapper">
  <ng-container *ngIf="!isFreemium && data?.sellersShareDistribution?.sellers?.length > 0">
    <div class="col-lg-12 leftOverview" *ngIf="directSellers?.length > 0 || resellers?.length > 0">
      <div class="sov-chart" *ngIf="directSellers?.length > 0">
        <h5>Direct Sellers</h5>
        <app-pie-chart [data]="directSellersChartData" [height]="'400px'"></app-pie-chart>
      </div>
      <div class="sov-chart" *ngIf="resellers?.length > 0">
        <h5>Resellers</h5>
        <app-pie-chart [data]="resellersChartData" [height]="'400px'"></app-pie-chart>
      </div>
    </div>
  </ng-container>
  <div class="col-lg-12 rightContainer" [ngClass]="{'p-4' : directSellers?.length <= 0 && resellers?.length <= 0}">
    <app-data-table-component [headers]="headers" [currentSort]="'paymentType'" [data]="sellers"
                              [limit]="showMoreLimit" (itemClick)="goTo($event)"></app-data-table-component>
  </div>
</div>

<ng-template #sellerNameTemplate let-item='item' let-row='row'>
  <ng-container *ngIf='item !== "Other"'>
    <img class="mr-1" src="https://cdn.pixalate.com/sellers/icons/apn/16x16/{{ row.sellerId }}.jpg" width="16" height="16" onerror="this.style.opacity=0;this.style.fontSize=0;" alt="Seller Icon">
  </ng-container>
  <span>{{ item }}</span>
</ng-template>

<ng-template #priceBidLowTemplate let-item='item' let-row='row'>
  <span>{{ item === 'N/A' ? 'N/A' : '$' + ( item | num:'1.1-2' ) }} - {{ row.priceBidHigh === 'N/A' ? 'N/A' : '$' + ( row.priceBidHigh | num:'1.1-2' ) }}</span>
</ng-template>
